import React, {cache, useEffect, useState} from 'react';
import axios from 'axios';
import UploadFile from '../components/UploadFile';
import CheckBox from '../components/CheckBox';
import Loading from '../components/Loading';
import ChatBotCohort from '../components/ChatBotCohort';
import CsvViewer from '../components/CsvViewer';

export default function CohortPage({setPage}){
    const [data, setData] = useState({}); //data is for saving data from flask(title, url...)
    const [uploadedFiles, setUploadedFiles] = useState([]);
    const [selected, setSelected] = useState([]);
    const [errorMsg, setErrorMsg] = useState('');
    const [loading, setLoading] = useState(false);
    const [imglist, setImglist] = useState([]);
    const [csvlist, setCsvlist] = useState([]);
    const [multiUploaded, setMultiUploaded] = useState(false);
    const [multiOptions, setmultiOptions] = useState([]); 
    const [mergeCol, setMergeCol] = useState('');
    const [merging, setMerging] = useState(false);
    const [mergedCsv, setMergedCsv] = useState([]);
    const [metadata, setMetadata] = useState([])
    const [features, setFeatures] = useState([])
    const [showTaskPanel, setShowTaskPanel] = useState(false);
    const [demoLoading, setDemoLoading] = useState(false);
    const [demoMsg, setDemoMsg] = useState("");

    useEffect(()=>{
        axios.get("/api/cohortpage") //<->methods["GET"]
        .then(res=>setData(res.data)); //setData->get res.data than save to state
    },[]); //[]-> only execute once (like the default state here)
    
    useEffect(() => {
        (async () => {
            try {
            const r = await fetch('/api/clear_uploads', { method: 'POST' });
            const j = await r.json();
            console.log('clear_uploads:', j);
            } catch (e) {
            console.error('clear_uploads failed:', e);
            }
        })();
        }, []);

    const getMultiColNames = async () => {
        try{
          const res = await axios.post('/api/get_multi_col_name',{
            page: 'cohort_multi',
          });
          return res.data.columns;
        } catch(err){
          console.error(err);
          return [];
        }
    }

    const getMergedCsv = async () => {
        try {
            const res = await axios.post("/api/merge_csv") ;
            const csvs = res.data.csvs || [];
            setMergedCsv(csvs[0])
        } catch (err){
            console.error(err);
        }
        
    }



    const handleMergeMulti = async (col) => {
        if (!col) return;
      
        try {
          setMerging(true);
          const res = await axios.post('/api/merge_multi', {
            column: col,
            page: 'cohort_multi',
          });
          console.log("merge result:", res.data);
        } catch (err) {
          console.error("merge failed:", err);
          console.error("server says:", err.response?.data);
        } finally {
          setMerging(false);
        }
      };

    const handleUpload = async (files, tag) => {
        if (!files || files.length === 0) {
        console.warn("沒有檔案被選取");
        return;
        }
        setUploadedFiles(files);
        console.log("Uploading...");
        const formData = new FormData();
        files.forEach(f => formData.append('file', f));
        // const ext = files[0].name.split('.').pop().toLowerCase();
        formData.append('type', tag);
      
        const res = await axios.post('/api/upload', formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        });
        console.log("上傳成功", res.data);
        if (tag === 'cohort_multi') {
            const cols = await getMultiColNames();   // 這裡要 await
            setmultiOptions(cols);
            setMultiUploaded(true)
          }
    };

    const handleDemoCohort = async () => {
        try {
            setDemoLoading(true);
            setDemoMsg("");

            const formData = new FormData();
            formData.append("type", "cohort_single");
            formData.append("demo", "true");

            await axios.post(
                "/api/upload",
                formData
            );

            setDemoMsg("✓ Demo cohort loaded");

        } catch (err) {
            console.error(err);
            setDemoMsg("X Demo cohort loading failed");
        } finally {
            setDemoLoading(false);
        }
    };

    const handleDemoFeature = async () => {
        try {
            setDemoLoading(true);
            setDemoMsg("");

            const formData = new FormData();

            formData.append(
                "task_type",
                "cohort_feature"
            );

            formData.append(
                "demo",
                "true"
            );

            await axios.post(
                "/api/upload_feature",
                formData
            );

            setDemoMsg("✓ Demo feature loaded");

        } catch (err) {
            console.error(err);
            setDemoMsg("X Demo feature loading failed");
        } finally {
            setDemoLoading(false);
        }
    };

    const startAnalysisSingle = async () => {
        setLoading(true);
        try {
            const res = await axios.post('/api/get_img',{
                selected: selected
            });
            setImglist(res.data.figs)
            // setCsvlist(res.data.csvs)
            console.log("🚀 圖片列表：", res.data.figs);
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    }

    async function submitFeature(metadata, features) {
        const formData = new FormData()
        formData.append("task_type", "cohort_feature")
        formData.append("metadata", metadata)
        for (const file of features) {
            formData.append(
            "features",
            file,
            file.webkitRelativePath
            )
        }
        await axios.post("/api/upload_feature", formData)
    }

    return(
        <div style={{backgroundColor: '#f9f7f2',}}>
            <div style={{textAlign:'center', display:'flex', 
                        alignItems:'center', marginLeft:'60px'}}>
                <button onClick={() => setPage('home')} 
                style={{...styles.page_button, backgroundColor: '#84D9AD'}}>
                Home Page
                </button>
                <button onClick={() => setPage('pathologic')} 
                style={{...styles.page_button, backgroundColor: '#86B6DD'}}>
                Pathologic Analysis
                </button>
                <button onClick={() => setPage('multicase')} 
                style={{...styles.page_button, backgroundColor: '#6e8f9f'}}>
                Multi-report Analysis
                </button>
            </div>
            <div style={{ textAlign: 'center', padding: '40px', 
                            display:'flex', gap:'30px', alignItems:'center'}}>
                {/* LOGO */}
                {data.logo_url &&(<img src={data.logo_url} alt="logo" style={{
                            width:'180px', marginBottom:'20px', marginLeft:'50px',
                            filter: 'contrast(80%) brightness(85%) hue-rotate(75deg)'
                        }}/>)}
                
                {/* TITLE */}
                <h1 style={{ color: "#ACABDD", fontSize: '3.5rem', 
                            fontFamily: `"Microsoft JhengHei", "Noto Sans TC", sans-serif`}}>
                    {data.title}</h1>
            </div>
            <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'flex-start',
                marginLeft: '100px',
                gap: '40px'  // 左右間距
                }}>
                {/* 左邊區塊：兩個上傳 */}
                <div style={{ display: 'flex', flexDirection: 'column', gap: '20px', overflowX: "auto", width:"30vw"}}>
                    <UploadFile
                    onUpload={(files) => handleUpload(files, 'cohort_single')}
                    accept={['.csv', '.xlsx']}
                    multiple={false}
                    style={{
                        ...styles.upload_area,
                        backgroundColor: '#8CD4D9',
                        color: '#f9f7f2'
                    }}
                    title={'Upload cohort sheet'}
                    subtitle={'Support single csv file'}
                    />
                    {<UploadFile
                    onUpload={(files) => handleUpload(files, 'cohort_multi')}
                    accept={['.xlsx', '.csv']}
                    multiple={true}
                    style={{
                        ...styles.upload_area,
                        backgroundColor: '#86B6DD',
                        color: '#f9f7f2'
                    }}
                    title={'Upload cohort files'}
                    subtitle={'Support multiple csv/excel file'}
                    />}
                    <button
                        onClick={handleDemoCohort}
                        disabled={demoLoading}
                        style={styles.demo_button}
                    >
                        {demoLoading
                            ? "Loading Demo..."
                            : "Use Demo Cohort"}
                    </button>
                    {demoMsg && (
                        <div
                            style={{
                                marginTop: "8px",
                                color: demoMsg.includes("✓")
                                    ? "#2e7d32"
                                    : "#d32f2f",
                                fontWeight: "600"
                            }}
                        >
                            {demoMsg}
                        </div>
                    )}
                    {/* Start TASK button */}
                    <button
                        onClick={() => setShowTaskPanel(true)}
                        style={{
                            ...styles.upload_area,
                            backgroundColor: '#8693dd',
                            color: '#f9f7f2',
                            borderRadius: "20px",
                            padding: "18px 32px",
                            width: "105%",
                            backgroundColor: "#7d89c7",
                            color: "#f9f7f2",
                            fontSize: "1.3rem",
                            fontWeight: "600",
                            border: "none",
                            cursor: "pointer",
                            boxShadow: "0 4px 12px rgba(0,0,0,0.3)",
                            transition: "transform 0.2s ease, box-shadow 0.2s ease",
                            fontFamily: "Noto Sans TC, sans-serif"
                        }}
                    >
                        Upload Features
                    </button>
                    {/* Upload panel */}
                    {showTaskPanel && (
                        <div
                        style={{
                            padding: 20,
                            borderRadius: 20,
                            width: "50%",
                        }}
                        >

                        <UploadFile
                            title="Upload metadata"
                            accept={[".csv"]}
                            multiple={false}
                            subtitle="Support csv file"
                            style={{
                            backgroundColor: "#9684b4",
                            color: "#f9f7f2",
                            borderRadius: "32px",
                            padding: "25px",
                            width: "280px",
                            fontSize: "1rem",
                            fontWeight: "300",
                            boxShadow: "0 4px 12px rgba(0,0,0,0.3)",
                            transition: "transform 0.2s ease, box-shadow 0.2s ease",
                            fontFamily: "Noto Sans TC, sans-serif",
                            marginBottom: 10
                            }}
                            onUpload={(f)=>setMetadata(f[0])}
                        />


                        <UploadFile
                            title="Upload feature folder"
                            accept={[".pt"]}
                            multiple={true}
                            directory={true}
                            subtitle="Support .pt file"
                            style={{
                            backgroundColor: "#7da2c2",
                            color: "#f9f7f2",
                            borderRadius: "32px",
                            padding: "25px",
                            width: "280px",
                            fontSize: "1rem",
                            fontWeight: "300",
                            boxShadow: "0 4px 12px rgba(0,0,0,0.3)",
                            transition: "transform 0.2s ease, box-shadow 0.2s ease",
                            fontFamily: "Noto Sans TC, sans-serif"
                            }}
                            onUpload={(newFiles)=>{
                            setFeatures(prev => [...prev, ...newFiles])
                            }}
                        />
                        <button
                            onClick={handleDemoFeature}
                            disabled={demoLoading}
                            style={{borderRadius: "16px",
                                    padding: "12px",
                                    cursor: "pointer",
                                    backgroundColor: "#84D9AD",
                                    color: "#202143",
                                    fontWeight: "700",
                                    border: "none",
                                    width: "100%",
                                    fontSize: "16px",
                                    marginTop: "20px"
                            }}
                        >
                            {demoLoading
                                ? "Loading Demo..."
                                : "Use Demo Cohort"}
                        </button>
                        {demoMsg && (
                            <div
                                style={{
                                    marginTop: "8px",
                                    color: demoMsg.includes("✓")
                                        ? "#2e7d32"
                                        : "#d32f2f",
                                    fontWeight: "600"
                                }}
                            >
                                {demoMsg}
                            </div>
                        )}

                        {/* Submit button */}
                        <button
                            disabled={!metadata || features.length === 0}
                            onClick={() => submitFeature(metadata, features)}
                            style={{
                            marginTop: 20,
                            padding: "10px 20px",
                            ...styles.upload_area,
                            borderRadius: "20px",
                            width: "50%",
                            backgroundColor: "#7d89c7",
                            color: "#f9f7f2",
                            fontSize: "1rem",
                            fontWeight: "600",
                            border: "none",
                            cursor: "pointer",
                            boxShadow: "0 4px 12px rgba(0,0,0,0.3)",
                            transition: "transform 0.2s ease, box-shadow 0.2s ease",
                            fontFamily: "Noto Sans TC, sans-serif"
                            }}
                        >
                            Submit
                        </button>
                        </div>

                    )}
                    {multiUploaded && (
                    <div style={{ marginTop: 16 }}>
                        <label style={{ display: 'block', marginBottom: 4 }}>
                        Please choose a column to merge the files:
                        </label>
                        <select
                        style={{ padding: 8 }}
                        value={mergeCol}
                        onChange={async (e) => {
                            const col = e.target.value;
                            setMergeCol(col);
                            await handleMergeMulti(col);
                        }}
                        disabled={merging}
                        >
                        <option value="">Select a column</option>
                        {multiOptions.map((opt) => (
                            <option key={opt} value={opt}>
                            {opt}
                            </option>
                        ))}
                        </select>
                        <button onClick={getMergedCsv} style={{ marginLeft: 12}}>
                            Merge files
                        </button>
                        {merging && <div style={{ marginTop: 8 }}>Merging files...</div>}
                        {mergedCsv && (
                            <CsvViewer base64Data={mergedCsv.url} 
                                        title={mergeCol.title}></CsvViewer>
                        )}
                    </div>
                    )}
                </div>

                {/* 右邊區塊：ChatBot */}
                <div style={{ flex: 1 }}>
                    <ChatBotCohort />
                </div>
                </div>
            {/*<div>
                <button onClick={() => {
                        if (!uploadedFiles || uploadedFiles.length === 0) {
                            setErrorMsg("Please at least upload a file.")
                        return;
                        }
                        if (selected.length === 0){
                            setErrorMsg("Please at least select a method.")
                            return;
                        }
                        setErrorMsg("")
                        console.log("準備分析：", uploadedFiles);
                        startAnalysisSingle();
                    }}
                    style={{...styles.start_button}}>
                {loading ? "Analyzing":"Start Analysis"}</button>
                <div className="relative min-h-screen">
                    {loading && <Loading />}
                </div>
                {errorMsg && (
                <div style={styles.error_msg}>
                    {errorMsg}
                </div>
                )}
                </div>*/}
        </div>
    )

};

const styles={
    page_button: {
        padding: '12px 26px',
        borderRadius: '8px',
        backgroundColor: '#86B6DD',
        fontWeight: '600',
        cursor: 'pointer',
        marginTop: '20px',
        fontSize: '16px',
        marginLeft:'1px',
        border:'0px',
        color:'#f9f7f2'
      },
      upload_area:{
        },
    start_button:{
        borderRadius: '32px',
        padding: '15px',
        width: '100%',
        maxWidth: '1250px',
        cursor: 'pointer',
        textAlign: 'center',
        boxShadow: '0 4px 12px rgba(0,0,0,0.3)',
        transition: 'transform 0.2s ease, box-shadow 0.2s ease',
        fontFamily: 'Noto Sans TC, sans-serif',
        marginLeft: '200px',
        marginTop: '30px',
        backgroundColor: '#CECED9',
        color:'#202143',
        fontSize:'1.2rem',
        fontWeight: '700',
        border:'none'
    },
    error_msg:{
        color: 'red',
        marginTop: '10px',
        fontWeight: 'bold',
        backgroundColor: '#ffe0e0',
        padding: '8px 12px',
        borderRadius: '8px'
    },
    demo_button: {
        borderRadius: "16px",
        padding: "12px",
        cursor: "pointer",
        backgroundColor: "#84D9AD",
        color: "#202143",
        fontWeight: "700",
        border: "none",
        width: "100%",
        fontSize: "16px",
    },
}
